import { BaseBillingEntity } from '/@/modules/billing/models/BaseBillingEntity';
import NumeralService from '/@/modules/core/app/services/NumeralService';
import { ColumnFormat } from '/@/modules/core/app/constants/data.constants';

export class BillingAddon extends BaseBillingEntity {
  /**
   * @var {number}
   */
  amount;

  /**
   * @var {string}
   */
  chargeType;

  /**
   * @var {string}
   */
  currencyCode;

  /**
   * @var {boolean}
   */
  enabledInPortal;

  /**
   * @var {string}
   */
  id;

  /**
   * @var {boolean}
   */
  isShippable;

  /**
   * @var {string}
   */
  name;

  /**
   * @var {string}
   */
  object;

  /**
   * @var {string}
   */
  periodUnit;

  /**
   * @var {number}
   */
  price;

  /**
   * @var {string}
   */
  pricingModel;

  /**
   * @var {number}
   */
  unitPrice;

  /**
   * @var {boolean}
   */
  showDescriptionInInvoices;

  /**
   * @var {boolean}
   */
  showDescriptionInQuotes;

  /**
   * @var {string}
   */
  status;

  /**
   * @var {boolean}
   */
  taxable;

  /**
   * @var {string}
   */
  type;

  constructor(model = {}) {
    super(model);

    this.amount = model.amount;
    this.chargeType = model.chargeType;
    this.currencyCode = model.currencyCode;
    this.enabledInPortal = model.enabledInPortal;
    this.id = model.id;
    this.isShippable = model.isShippable;
    this.name = model.name;
    this.object = model.object;
    this.periodUnit = model.periodUnit;
    this.price = model.price;
    this.pricingModel = model.pricingModel;
    this.unitPrice = model.unitPrice;
    this.showDescriptionInInvoices = model.showDescriptionInInvoices;
    this.showDescriptionInQuotes = model.showDescriptionInQuotes;
    this.status = model.status;
    this.taxable = model.taxable;
    this.type = model.type;
    this.metaData = model.metaData;
  }

  get displayPrice() {
    return NumeralService.formatValue(this.price / 100, ColumnFormat.FORMAT_CURRENCY);
  }
}
